/**
 * Reads a 409 response and calls fieldSetterFn with the server message.
 * Non-409 errors are silently ignored — the caller's submit handler is the hard stop.
 */
export const handleDuplicateError = (error, fieldSetterFn) => {
  if (error?.response?.status === 409) {
    const message = error.response?.data?.message || '';
    fieldSetterFn(message || 'This value is already in use.');
  }
};

/**
 * Returns a standard user-friendly duplicate message for a given field name.
 */
export const formatDuplicateMessage = (field, value) => {
  if (field === 'email' || field === 'primaryEmail') {
    return 'This email is already registered.';
  }
  if (field === 'phone' || field === 'primaryPhone') {
    return 'This phone number is already registered.';
  }
  return 'This value is already in use.';
};
